<div>
    <h1 class="text-vivid-royal-500 dark:text-dark-khaki-50 text-lg md:text-xl">Fotocargas Requeridas</h1>
</div>
<div class="flex items-start gap-2 mt-3 p-3 bg-amber-50 dark:bg-amber-900/20 border border-amber-300 dark:border-amber-700 rounded-lg">
  <i class="pi pi-info-circle text-amber-500 mt-0.5 "></i>
  <p class="text-xs text-amber-700 dark:text-amber-300">El campo de <b>Placas</b> debe estar siempre activo para poder guardar los cambios. Este campo es obligatorio.<br> Una vez aceptado las placas no se podrá cambiar.</p>
</div>
<div class="grid grid-cols-1 md:grid-cols-2 text-left mx-auto gap-x-6 gap-y-3 mt-5">
    @for(item of allPhotoTypes; track item.type_id) {
        <div class="flex pb-4 px-4 justify-between items-center">
            <label class="text-sm text-vivid-royal-500 dark:text-vivid-royal-200 font-medium dark:text-dark-khaki-50">{{ item.description }}</label>
            <p-toggleswitch [ngModel]="isSelected(item)" [disabled]="disableSwitch(item)" (onChange)="selectPhotoType(item)" />
        </div>
    }
</div>

@if(showMessageError) {
    <div class="text-sm text-red-700 bg-red-100 border border-red-300 rounded-lg px-3 py-2">{{ messagesError }}</div>
}

@if(isAdmin) {
    <div class="my-5 flex justify-end">
        <button pButton label="Guardar" icon="pi pi-check" class="p-button-sm" type="button" [disabled]="!isPlatesSelected()" (click)="showConfirmDialog()"></button>
    </div>
}

<p-dialog header="Confirmar cambios" [(visible)]="showConfirm" [modal]="true" [style]="{width: '400px'}">
    <p class="text-sm" [innerHTML]="messageConfirm"></p>
    <ng-template #footer>
        <button pButton label="Cancelar" class="p-button-text" (click)="showConfirm=false"></button>
        <button pButton label="Aceptar" (click)="showConfirm=false; savePhotos()"></button>
    </ng-template>
</p-dialog>
